import { Component, OnInit, Input } from '@angular/core';
import { SolicitacaoService } from 'src/app/service/solicitacao/solicitacao.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'app-reeducando',
  templateUrl: './reeducando.component.html',
  styleUrls: ['./reeducando.component.css']
})
export class ReeducandoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  charNum = 5000;

  constructor(
    public service: SolicitacaoService,
    public authService: AuthService) {
  }

  ngOnInit() {

    if (!this.visualizacao && !this.edicao) {

      this.service.solicitacao.controls.descricaoReclamacao.setValue('');

    }

  }

  contemErro(str) {
    return this.service.solicitacao.controls[str].touched &&
      this.service.solicitacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }
}
